/** URL query param holding the base64url-encoded CRM field conditions */
export const CRM_FILTERS_QUERY_KEY = "crm_filters";

/** Page size for the filterable-field catalog; the largest size the backend allows */
export const CRM_FILTER_FIELD_PAGE_SIZE = 500;

/** The catalog only changes when an admin edits the layout, so it is held for an hour */
export const CRM_FILTER_FIELD_CACHE_SECONDS = 3600;

export const CRM_FILTER_OPERAND = {
  EQUALS: "equals",
  CONTAINS: "contains",
  MIN_VALUE: "min_value",
  MAX_VALUE: "max_value",
  DATE_FROM: "date_from",
  DATE_TO: "date_to",
  IS_CHECKED: "is_checked",
  VALUES: "values",
  MATCH: "match",
} as const;

export const CRM_TEXT_MATCH_MODE = {
  CONTAINS: "CONTAINS",
  EQUALS: "EQUALS",
} as const;

export type CrmTextMatchMode =
  (typeof CRM_TEXT_MATCH_MODE)[keyof typeof CRM_TEXT_MATCH_MODE];

export const CRM_TEXT_MATCH_OPTIONS = [
  { value: CRM_TEXT_MATCH_MODE.CONTAINS, label: "Contains" },
  { value: CRM_TEXT_MATCH_MODE.EQUALS, label: "Equals" },
];

export const CRM_CHECKBOX_STATE = {
  CHECKED: "CHECKED",
  UNCHECKED: "UNCHECKED",
} as const;

// "Yes"/"No" rather than "Checked"/"Unchecked" - it reads better as a filter and matches the
// seeded Yes/No single-selects elsewhere in the CRM
export const CRM_CHECKBOX_OPTIONS = [
  { value: CRM_CHECKBOX_STATE.CHECKED, label: "Yes" },
  { value: CRM_CHECKBOX_STATE.UNCHECKED, label: "No" },
];

export const CRM_MULTI_SELECT_MATCH_OPTIONS = [
  { value: "0", label: "Has any of" },
  { value: "1", label: "Has all of" },
];
